/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShipmentLimitsLiftgate } from './ShipmentLimitsLiftgate';
import {
    ShipmentLimitsLiftgateFromJSON,
    ShipmentLimitsLiftgateFromJSONTyped,
    ShipmentLimitsLiftgateToJSON,
    ShipmentLimitsLiftgateToJSONTyped,
} from './ShipmentLimitsLiftgate';
import type { ShipmentLimitsDangerousGoods } from './ShipmentLimitsDangerousGoods';
import {
    ShipmentLimitsDangerousGoodsFromJSON,
    ShipmentLimitsDangerousGoodsFromJSONTyped,
    ShipmentLimitsDangerousGoodsToJSON,
    ShipmentLimitsDangerousGoodsToJSONTyped,
} from './ShipmentLimitsDangerousGoods';
import type { ShipmentLimitsLineItem } from './ShipmentLimitsLineItem';
import {
    ShipmentLimitsLineItemFromJSON,
    ShipmentLimitsLineItemFromJSONTyped,
    ShipmentLimitsLineItemToJSON,
    ShipmentLimitsLineItemToJSONTyped,
} from './ShipmentLimitsLineItem';
import type { ShipmentLimitsShipment } from './ShipmentLimitsShipment';
import {
    ShipmentLimitsShipmentFromJSON,
    ShipmentLimitsShipmentFromJSONTyped,
    ShipmentLimitsShipmentToJSON,
    ShipmentLimitsShipmentToJSONTyped,
} from './ShipmentLimitsShipment';
import type { ShipmentLimitsSavedCommodity } from './ShipmentLimitsSavedCommodity';
import {
    ShipmentLimitsSavedCommodityFromJSON,
    ShipmentLimitsSavedCommodityFromJSONTyped,
    ShipmentLimitsSavedCommodityToJSON,
    ShipmentLimitsSavedCommodityToJSONTyped,
} from './ShipmentLimitsSavedCommodity';
import type { ShipmentLimitsAdvisory } from './ShipmentLimitsAdvisory';
import {
    ShipmentLimitsAdvisoryFromJSON,
    ShipmentLimitsAdvisoryFromJSONTyped,
    ShipmentLimitsAdvisoryToJSON,
    ShipmentLimitsAdvisoryToJSONTyped,
} from './ShipmentLimitsAdvisory';
import type { ShipmentLimitsFlatbed } from './ShipmentLimitsFlatbed';
import {
    ShipmentLimitsFlatbedFromJSON,
    ShipmentLimitsFlatbedFromJSONTyped,
    ShipmentLimitsFlatbedToJSON,
    ShipmentLimitsFlatbedToJSONTyped,
} from './ShipmentLimitsFlatbed';
import type { ShipmentLimitsTemperatureHandling } from './ShipmentLimitsTemperatureHandling';
import {
    ShipmentLimitsTemperatureHandlingFromJSON,
    ShipmentLimitsTemperatureHandlingFromJSONTyped,
    ShipmentLimitsTemperatureHandlingToJSON,
    ShipmentLimitsTemperatureHandlingToJSONTyped,
} from './ShipmentLimitsTemperatureHandling';

/**
 * Numeric limits and configurable rules the backend enforces on shipment quoting requests. The
 * frontend reads these from `GET /shipment-limits` and uses them for client-side validation so
 * the same numbers are used in both places. Grouped by category so new categories can be added
 * without breaking existing clients. The one exception is `advisory`, which is never enforced and
 * only drives soft warnings in the client.
 * 
 * @export
 * @interface ShipmentLimits
 */
export interface ShipmentLimits {
    /**
     * 
     * @type {ShipmentLimitsLineItem}
     * @memberof ShipmentLimits
     */
    lineItem: ShipmentLimitsLineItem;
    /**
     * 
     * @type {ShipmentLimitsShipment}
     * @memberof ShipmentLimits
     */
    shipment: ShipmentLimitsShipment;
    /**
     * 
     * @type {ShipmentLimitsLiftgate}
     * @memberof ShipmentLimits
     */
    liftgate: ShipmentLimitsLiftgate;
    /**
     * 
     * @type {ShipmentLimitsFlatbed}
     * @memberof ShipmentLimits
     */
    flatbed: ShipmentLimitsFlatbed;
    /**
     * 
     * @type {ShipmentLimitsSavedCommodity}
     * @memberof ShipmentLimits
     */
    savedCommodity: ShipmentLimitsSavedCommodity;
    /**
     * 
     * @type {ShipmentLimitsDangerousGoods}
     * @memberof ShipmentLimits
     */
    dangerousGoods: ShipmentLimitsDangerousGoods;
    /**
     * 
     * @type {ShipmentLimitsTemperatureHandling}
     * @memberof ShipmentLimits
     */
    temperatureHandling: ShipmentLimitsTemperatureHandling;
    /**
     * 
     * @type {ShipmentLimitsAdvisory}
     * @memberof ShipmentLimits
     */
    advisory: ShipmentLimitsAdvisory;
    /**
     * Commodity descriptions that are not accepted on the platform (case-insensitive exact match).
     * @type {Array<string>}
     * @memberof ShipmentLimits
     */
    prohibitedCommodityDescriptions: Array<string>;
}

/**
 * Check if a given object implements the ShipmentLimits interface.
 */
export function instanceOfShipmentLimits(value: object): value is ShipmentLimits {
    if (!('lineItem' in value) || value['lineItem'] === undefined) return false;
    if (!('shipment' in value) || value['shipment'] === undefined) return false;
    if (!('liftgate' in value) || value['liftgate'] === undefined) return false;
    if (!('flatbed' in value) || value['flatbed'] === undefined) return false;
    if (!('savedCommodity' in value) || value['savedCommodity'] === undefined) return false;
    if (!('dangerousGoods' in value) || value['dangerousGoods'] === undefined) return false;
    if (!('temperatureHandling' in value) || value['temperatureHandling'] === undefined) return false;
    if (!('advisory' in value) || value['advisory'] === undefined) return false;
    if (!('prohibitedCommodityDescriptions' in value) || value['prohibitedCommodityDescriptions'] === undefined) return false;
    return true;
}

export function ShipmentLimitsFromJSON(json: any): ShipmentLimits {
    return ShipmentLimitsFromJSONTyped(json, false);
}

export function ShipmentLimitsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimits {
    if (json == null) {
        return json;
    }
    return {
        
        'lineItem': ShipmentLimitsLineItemFromJSON(json['lineItem']),
        'shipment': ShipmentLimitsShipmentFromJSON(json['shipment']),
        'liftgate': ShipmentLimitsLiftgateFromJSON(json['liftgate']),
        'flatbed': ShipmentLimitsFlatbedFromJSON(json['flatbed']),
        'savedCommodity': ShipmentLimitsSavedCommodityFromJSON(json['savedCommodity']),
        'dangerousGoods': ShipmentLimitsDangerousGoodsFromJSON(json['dangerousGoods']),
        'temperatureHandling': ShipmentLimitsTemperatureHandlingFromJSON(json['temperatureHandling']),
        'advisory': ShipmentLimitsAdvisoryFromJSON(json['advisory']),
        'prohibitedCommodityDescriptions': json['prohibitedCommodityDescriptions'],
    };
}

  export function ShipmentLimitsToJSON(json: any): ShipmentLimits {
      return ShipmentLimitsToJSONTyped(json, false);
  }

  export function ShipmentLimitsToJSONTyped(value?: ShipmentLimits | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lineItem': ShipmentLimitsLineItemToJSON(value['lineItem']),
        'shipment': ShipmentLimitsShipmentToJSON(value['shipment']),
        'liftgate': ShipmentLimitsLiftgateToJSON(value['liftgate']),
        'flatbed': ShipmentLimitsFlatbedToJSON(value['flatbed']),
        'savedCommodity': ShipmentLimitsSavedCommodityToJSON(value['savedCommodity']),
        'dangerousGoods': ShipmentLimitsDangerousGoodsToJSON(value['dangerousGoods']),
        'temperatureHandling': ShipmentLimitsTemperatureHandlingToJSON(value['temperatureHandling']),
        'advisory': ShipmentLimitsAdvisoryToJSON(value['advisory']),
        'prohibitedCommodityDescriptions': value['prohibitedCommodityDescriptions'],
    };
}

